import '../segment/segment';

// Stimulus
import { Application } from 'stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';

const application = Application.start();
const context = require.context('../segment/controllers', true, /\.js$/);
application.load(definitionsFromContext(context));
